import { toast } from "react-toastify";
import { buildPharmacySsoUrl } from "../../utils/hmsPharmacySso";

/**
 * "HMS Pharmacy" nav item → opens HIMS Pharmacy Billing in a NEW TAB.
 *
 * The signed SSO url is built on the client from the current session/UI data
 * (no backend call). A FRESH url is generated on every click — the nonce is
 * single-use and the url expires within ~2 minutes, so urls are never reused.
 *
 * `providerData` here is the provider object (MainMenu passes providerData.provider).
 */
const HmsPharmacy = ({ providerData }) => {
  const openPharmacyBilling = (e) => {
    e.preventDefault();

    // Identity from the current session/UI (robust to either provider shape).
    const session = {
      u: localStorage.getItem("userID"),
      nm: providerData?.person?.name || providerData?.provider?.person?.name,
      em: providerData?.email || providerData?.provider?.email,
      mb: providerData?.mobile || providerData?.provider?.mobile,
      org:
        process.env.REACT_APP_HMS_PROVIDER_SSO_ORG ||
        providerData?.scribeClinicId ||
        providerData?.provider?.scribeClinicId,
    };
    // eslint-disable-next-line no-console
    console.log("[HMS Pharmacy SSO] session data:", session);

    const url = buildPharmacySsoUrl(session);

    if (!url) {
      toast.error("HMS Pharmacy is not configured.");
      return;
    }

    // Open the fresh signed url in a new tab. HIMS renders its own error page
    // there on any SSO failure (bad signature, expired, replayed nonce,
    // unmapped org, disabled account).
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <a onClick={openPharmacyBilling} style={{ cursor: "pointer" }}>
      Pharmacy
    </a>
  );
};

export default HmsPharmacy;
